export interface EventRepeatLabelProps {
  name: string
}
